import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconButton from '@mui/material/IconButton';
import { connect, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import * as userActions from "../../actions/index";


const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" :user_info.school_code;


function DeactivateRoleModal(props) {
    const [managersByRole, setManagersByRole] = useState([])
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const dispatch = useDispatch();

    const GetAllManagersByRoleId = async () => {
        dispatch(userActions.GetAllManagersByRoleId(props.role_id)).then((response) => {
            if (response.success === true) {
                setManagersByRole(response.data.rows)
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }

        });
    };

    useEffect(() => {
        GetAllManagersByRoleId()
    }, [])

    const submitData = (e) => {
        props.handleChange(e, props.role_uuid, false, props.role_name)
        handleClose()
    }

    return (
        <>
            <Tooltip title="Activate/Deactivate Role" placement="top">
                <IconButton variant="primary" onClick={handleShow}>
                    <i className="bi bi-bell-slash"></i>
                </IconButton>
            </Tooltip>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Deactivate Role</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {managersByRole.length > 0 ?
                            <p className='text-center mb-0'>
                                This Role is currently assigned to the following User's :-   {managersByRole.map((item) => {
                                    return (<Link to={`/${school_code}/user-list/edit-user/${item.user_uuid}`}>{item.manger_name} </Link>)
                                })}.
                                Please assign the names to a different Role before deactivating it.
                            </p>
                            :
                            <p className='text-center mb-0'>
                                Do you want deactivate this role ?
                            </p>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className=' justify-content-center border-0 pt-0'>
                    <Button className='btn-sm' variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    {managersByRole.length === 0 ?
                        <Button className='btn-sm' variant="primary" onClick={submitData}>
                            Deactivate
                        </Button>
                        : ""
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeactivateRoleModal;